/** What the player wants to do this tick, independent of keyboard or touch. */
export interface Actions {
  gas: boolean;
  brake: boolean;
  laneLeft: boolean;
  laneRight: boolean;
  hop: boolean;
  pause: boolean;
  horn: boolean;
}

export function emptyActions(): Actions {
  return { gas: false, brake: false, laneLeft: false, laneRight: false, hop: false, pause: false, horn: false };
}

type Pulse = 'laneLeft' | 'laneRight' | 'hop' | 'pause' | 'horn';
type Hold = 'gas' | 'brake';

/** Collects held buttons and one-shot presses from every input source. */
export class InputState {
  private readonly held = { gas: new Set<string>(), brake: new Set<string>() };
  private pulses = new Set<Pulse>();

  press(action: Pulse): void {
    this.pulses.add(action);
  }

  hold(action: Hold, source: string, down: boolean): void {
    if (down) this.held[action].add(source);
    else this.held[action].delete(source);
  }

  releaseAll(): void {
    this.held.gas.clear();
    this.held.brake.clear();
    this.pulses.clear();
  }

  /** Read this tick's actions; one-shot presses are consumed. */
  consume(): Actions {
    const actions: Actions = {
      gas: this.held.gas.size > 0,
      brake: this.held.brake.size > 0,
      laneLeft: this.pulses.has('laneLeft'),
      laneRight: this.pulses.has('laneRight'),
      hop: this.pulses.has('hop'),
      pause: this.pulses.has('pause'),
      horn: this.pulses.has('horn'),
    };
    this.pulses = new Set();
    return actions;
  }
}
